
export const GET_DB_ATTACH_PARTY_REQUESTED = 'dbAttachParty/GET_DB_ATTACH_PARTY_REQUESTED';
export const GET_DB_ATTACH_PARTY_SUCCESS = 'dbAttachParty/GET_DB_ATTACH_PARTY_SUCCESS';
export const GET_DB_ATTACH_PARTY_FAILURE = 'dbAttachParty/GET_DB_ATTACH_PARTY_FAILURE';

export const UPDATE_DB_ATTACH_PARTY_REQUESTED = 'dbAttachParty/UPDATE_DB_ATTACH_PARTY_REQUESTED';
export const UPDATE_DB_ATTACH_PARTY_SUCCESS = 'dbAttachParty/UPDATE_DB_ATTACH_PARTY_SUCCESS';
export const UPDATE_DB_ATTACH_PARTY_FAILURE = 'dbAttachParty/UPDATE_DB_ATTACH_PARTY_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  dbAttachPartyConfigData: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_DB_ATTACH_PARTY_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false
      };
    }
    case GET_DB_ATTACH_PARTY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        dbAttachPartyConfigData: action.result,
      };
    }
    case GET_DB_ATTACH_PARTY_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
        dbAttachPartyConfigData: []
      };
    }
    case UPDATE_DB_ATTACH_PARTY_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
    case UPDATE_DB_ATTACH_PARTY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_DB_ATTACH_PARTY_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getDBAttachPartyConfig = (id) => {
  return {
    types: [GET_DB_ATTACH_PARTY_REQUESTED, GET_DB_ATTACH_PARTY_SUCCESS, GET_DB_ATTACH_PARTY_FAILURE],
    promise: client => client.get(`getDBAttachPartyConfig/${id}`)
  };
};

export const updateDBAttachPartyConfig = (data, id) => {
  return {
    types: [UPDATE_DB_ATTACH_PARTY_REQUESTED, UPDATE_DB_ATTACH_PARTY_SUCCESS, UPDATE_DB_ATTACH_PARTY_FAILURE],
    promise: client => client.post(`updateDBAttachPartyConfig/${id}`, { data })

  };
};
